/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable dot-notation */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable array-callback-return */
/* eslint-disable react/no-unused-state */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable quote-props */
/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import React, { Component } from 'react';

import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import ReactTooltip from 'react-tooltip';
import axios from 'axios';
import config from '../../../../moramma-config.json';
import logger from '../../../../logger';
import Map from '../../../RegisterScreen/Map';
import CountryCode from './country_code_all.json';


import classes from '../ConfigurationScreenContent.css';
import Aux from '../../../../hoc/Aux';
import lang from '../../../../lang.json';


class ConfigurationScreenContentAccount extends Component {
  state = {
    locationName: '',
    locationSlogan: '',
    locationImg: '',
    newUrl: '',
    txtImageError: '',
    showBlock: '',
    userData: {},
    txtlatlong: '',
    txtaddress: '',
    txtLat: '',
    txtLng: '',
    language: '',
    selectArea: '',
    selectCountry: '',
    selectFloorNumber: '',
    selectSpotType: ''
  }
  
  async componentDidMount() {
    // Retrive data from API
    await this.fetchUserData();
    console.error(CountryCode);
  }

  
  /**
   * @description Clear all data (atm the token) from localstorage
   */
  logOut = () => {
      logger.debug('[ManagerScreen|logOut] Logging out ...');
      localStorage.clear();
      this.setState({ logged: false });
      window.location.reload();
    }

    /**
     * @description
     * fetch user data
     */
    fetchUserData = async () => {
        const localtoken = localStorage.getItem('API');
        if (!localtoken) {
          this.logOut();
        }
  
        // Call 
        await axios({
          method: 'post',
          url: `${config.BASE_API}/react/user`,
          headers: {
            Authorization: `Bearer ${localtoken}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          data: { token: localtoken }
        }).then(async items => {
          // Update state
          // this.setState({ roomName: items.data.data.location.name, userDefaultPlaylist: items.data.data.defaults.defaultPlaylist, userData: items.data.data.location });        
          this.setState({
            locationName: items.data.data.location.name,
            locationSlogan: items.data.data.location.slogan,
            locationImg: items.data.data.location.pic,
            newUrl: items.data.data.location.pic,
            userData: items.data.data,
            language: items.data.data.owner.language,
            selectArea: items.data.data.location.size.radius,
            selectCountry: items.data.data.location.size.country,
            selectSpotType: items.data.data.location.spotType,
            selectFloorNumber: items.data.data.location.floorNumber,
            }); 
       //   console.warn('ok data', items.data.data);
        }).catch(err => {
          logger.error('[ManagerScreen|fetchUserData] Error during  API/react/user call', err);
          this.logOut();
        });
      };
      

    onChangeUrlImg = (event) => {     
        const txt = event.target.value;
        const RE_MAIL = new RegExp(/(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|png)/i);
        if (RE_MAIL.test(txt)) {
            // send link calling server API
            this.setState({ newUrl: event.target.value, txtImageError: false });
        } else {
            this.setState({ txtImageError: true });
        } 
    }

    onChangeTxtLocationName = (event) => {
      this.setState({ locationName: event.target.value });
  }

  onChangeTxtLocationSlogan = (event) => {
      this.setState({ locationSlogan: event.target.value });
  }

  showDatiAccount = () => {
    this.setState({ showBlock: 'datiAccount' });
}

  showAddress = () => {
    this.setState({ showBlock: 'address' });
  }

  showdeleteAccount = () => {
    this.setState({ showBlock: 'deleteAccount' });
  }

  updateAccount = async () => {
    const localtoken = localStorage.getItem('API');
      if (!localtoken) {
        this.logOut();
      }

    const { userData } = this.state;
    userData.location.name = this.state.locationName;
    userData.location.slogan = this.state.locationSlogan;
    userData.location.pic = this.state.newUrl;
    userData.location.size.radius = this.state.selectArea;
    userData.location.size.country = this.state.selectCountry;
    userData.location.spotType = this.state.selectSpotType;
    userData.location.floorNumber = this.state.selectFloorNumber;
            
      // Call 
      await axios({
        method: 'put',
        url: `${config.BASE_API}/react/location`,
        headers: {
          Authorization: `Bearer ${localtoken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data: 
        { 
          token: localtoken,
          location: userData.location
        }
      }).then(async items => {
        this.setState({
          locationName: items.data.data.location.name,
          locationSlogan: items.data.data.location.slogan,
          locationImg: items.data.data.location.pic,
          userData: items.data.data
          }); 
          
          ToastsStore.success('Updated!');
      }).catch(err => {
        logger.error('[ManagerScreen|fetchUserData] Error during  API/react/user call', err);
      });
  }

  updateAccountAddress = async () => {
    const localtoken = localStorage.getItem('API');
      if (!localtoken) {
        this.logOut();
      }

    const user = this.state.userData;
    user.location.address = this.state.txtaddress;
    user.location.lat = this.state.txtLat;
    user.location.lng = this.state.txtLng;

      // Call 
      await axios({
        method: 'put',
        url: `${config.BASE_API}/react/location`,
        headers: {
          Authorization: `Bearer ${localtoken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data: 
        { 
          token: localtoken,
          location: user.location
        }
      }).then(async items => {
        this.setState({
          userData: items.data.data
          }); 
          
          ToastsStore.success('Updated!');
      }).catch(err => {
        logger.error('[ManagerScreen|fetchUserData] Error during  API/react/user call', err);
      });
  }

    link = (latlng, street, lat, lng) => {
      this.setState({ 
        txtlatlong: latlng, txtaddress: street, txtLat: lat, txtLng: lng 
      });
  }

  deleteAccount = async () => {
    const localtoken = localStorage.getItem('API');
    if (!localtoken) {
      this.logOut();
    }

    // Call 
    await axios({
      method: 'delete',
      url: `${config.BASE_API}/react/location`,
      headers: {
        Authorization: `Bearer ${localtoken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: 
      { 
        token: localtoken
      }
    }).then(async () => {
      console.warn('deleted');
      this.logOut();
    }).catch(err => {
      logger.error('[ManagerScreen|fetchUserData] Error during  API/react/user call', err);
    });
  }

  updateLanguage = async () => {
    const localtoken = localStorage.getItem('API');
    if (!localtoken) {
      this.logOut();
    }

    const user = this.state.userData;

    if (user.owner.language === 'EN-en') {
      user.owner.language = 'IT-it';
    } else {
      user.owner.language = 'EN-en';
    }

      // Call 
      await axios({
        method: 'put',
        url: `${config.BASE_API}/react/owner`,
        headers: {
          Authorization: `Bearer ${localtoken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data: 
        { 
          token: localtoken,
          owner: user.owner,
          room: user.location.name
        }
      }).then(async (items) => {
        this.setState({
          userData: items.data.data,
          language: items.data.data.owner.language
          }); 
          
          ToastsStore.success('Fatto! Potresti dover riavviare le pagine per visualizzare le modifiche.');
      }).catch(err => {
        logger.error('[ManagerScreen|fetchUserData] Error during  API/react/user call', err);
      });
  }


  onAreaSelectChanges = (e) => {
    this.setState({ selectArea: e.target.value });
}

  onCountrySelectChanges = (e) => {
    console.log('valore:', e.target.value);
    this.setState({ selectCountry: e.target.value });
  }

onFloorNumberChanges= (e) => {
    this.setState({ selectFloorNumber: e.target.value });
}

onSpotRadiusChanges= (e) => {
    this.setState({ selectSpotType: e.target.value });
}


  render() {
    return (
      <Aux>
        <div className="container-fluid">
          <div className="row">
            <div className="col" />
            <div className={`col-8 ${classes.TitleCard}`}> 
              <div className="row">
                <div className="col-8">
                  <br />
                  <h3> 
                    {lang[this.props.language].confscreen_account_title_1of2}
                    <br />
                    {lang[this.props.language].confscreen_account_title_2of2}
                  </h3>
                  <br />
                  <br />
                  <p className={classes.DescriptionCard}>
                    {lang[this.props.language].confscreen_account_description}
                  </p>
                </div>
                <div className="col-4 align-self-center">
                  <img src={require('../../../../assets/img/account.png')} alt="img-psw" className={classes.ImgHome} />
                </div>
              </div>
            </div>
            <div className="col" />
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col" />
            <div className="col-8">
              <h3>Modifica</h3>
              <div className="row">
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`} onClick={this.showDatiAccount}>
                  <img className={classes.ImgButtonLink} src={require('../../../../assets/svg/ic-user.svg')} alt="img" />
                  <p className={classes.DescriptionButton}>
                    <br />
                    {lang[this.props.language].confscreen_account_btn_edit_info}
                  </p>
                </div>
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`} onClick={this.showAddress}>
                  <img className={classes.ImgButtonLink} src={require('../../../../assets/svg/ic-map.svg')} alt="img" />
                  <p className={classes.DescriptionButton}>
                    <br />
                    {lang[this.props.language].confscreen_account_btn_edit_addr}
                  </p>
                </div>
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`} onClick={this.updateLanguage}>
                  <img className={classes.ImgButtonLink} src={require('../../../../assets/svg/flag-regular.svg')} alt="img" />
                  <p className={classes.DescriptionButton}>
                    <br />
                        {lang[this.props.language].confscreen_account_btn_edit_lang}
                    <br />
                        {this.state.language}
                  </p>
                </div>
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`} onClick={this.showdeleteAccount}>
                  <img className={classes.ImgButtonLink} src={require('../../../../assets/svg/trash-solid.svg')} alt="img" />
                  <p className={classes.DescriptionButton}>
                    <br />
                    {lang[this.props.language].confscreen_account_btn_edit_delete}
                  </p>
                </div>
              </div>
            </div>
            <div className="col" />
          </div>
          <br />
          <br />
          {
            this.state.showBlock === 'datiAccount' 
            ? (
                <div className="row">
                <div className="col" />
                <div className={`col-8 ${classes.DefCard}`}> 
                  <div className="row">
                    <div className="col-12">
                      <br />
                      <h3> 
                        {lang[this.props.language].confscreen_account_edit_account_title}
                        <i data-html="true" data-place="right" data-tip={lang[this.props.language].confscreen_account_edit_account_hint} className={`fas fa-question-circle ${classes.HelpIcon} ${classes.TxtLeft}`} />
                      </h3>
                      <br />
                      <hr />
                      <br />
                        <p>
                        {lang[this.props.language].confscreen_account_edit_account_name}: {this.state.userData.location.name}
                        </p>
                        <p><b>{lang[this.props.language].confscreen_account_edit_account_name_contact}</b></p>
                        <div className="col-6">
                            <TextField
                                label={lang[this.props.language].confscreen_account_edit_account_txt_name}
                                type="text"
                                name="LocationName"
                                autoComplete="autocompl"
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                disabled
                                onChange={this.onChangeTxtLocationName}
                            />
                        </div>
                        <br />
                        <p>
                        {lang[this.props.language].confscreen_account_edit_account_slogan}:  {this.state.userData.location.slogan}
                        </p>
                        <div className="col-6">
                            <TextField
                                label={lang[this.props.language].confscreen_account_edit_account_txt_slogan}
                                type="text"
                                name="LocationName"
                                autoComplete="autocompl"
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                onChange={this.onChangeTxtLocationSlogan}
                            />
                        </div>
                        <br />
                            <p>{lang[this.state.language].registerscreen_sel_area}</p>
                            <div className="col-6">
                            <Select
                                labelId="demo-customized-select-label"
                                id="demo-customized-select"
                                value={this.state.selectArea}
                                onChange={this.onAreaSelectChanges}
                            >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={75}>75</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                                <MenuItem value={125}>125</MenuItem>
                                <MenuItem value={150}>150</MenuItem>
                                <MenuItem value={175}>175</MenuItem>
                                <MenuItem value={200}>200</MenuItem>
                                <MenuItem value={250}>250</MenuItem>
                                <MenuItem value={350}>350</MenuItem>
                                <MenuItem value={450}>450</MenuItem>
                                <MenuItem value={0}>Nessun limite</MenuItem>
                            </Select>
                            </div>
                        <br />
                        <br />
                        <br />
                            <p>Se vuoi impostare il raggio di azione per tutto lo stato, selezionalo da qua:</p>
                            <div className="col-6">
                            <Select
                                labelId="demo-customized-select-label"
                                id="demo-customized-select"
                                value={this.state.selectCountry}
                                onChange={this.onCountrySelectChanges}
                            >
                              {
                                  CountryCode.map((el) => (<MenuItem value={el.code}>{el.code} - {el.name}</MenuItem>))
                              }
                              <MenuItem value="none">Nessuna / none</MenuItem>
                            </Select>
                            </div>
                        <br />
                        <br />
                            <p>{lang[this.state.language].registerscreen_sel_floor}</p>
                            <div className="col-6">
                            <Select
                                labelId="demo-customized-select-label"
                                id="demo-customized-select"
                                value={this.state.selectFloorNumber}
                                onChange={this.onFloorNumberChanges}
                            >
                                <MenuItem value={0}>0</MenuItem>
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={6}>6</MenuItem>
                                <MenuItem value={7}>7</MenuItem>
                                <MenuItem value={8}>8</MenuItem>
                            </Select>
                            </div>
                        <br />
                        <br />
                            <p>{lang[this.state.language].registerscreen_sel_radius}</p>
                            <div className="col-6">
                            <Select
                                labelId="demo-customized-select-label"
                                id="demo-customized-select"
                                value={this.state.selectSpotType}
                                onChange={this.onSpotRadiusChanges}
                            >
                                <MenuItem value="Bar">Bar</MenuItem>
                                <MenuItem value="Palestra">Palestra</MenuItem>
                                <MenuItem value="Pub">Pub</MenuItem>
                                <MenuItem value="Discoteca">Discoteca</MenuItem>
                                <MenuItem value="Università">Università</MenuItem>
                                <MenuItem value="Ristorante">Ristorante</MenuItem>
                                <MenuItem value="Fiera">Fiera</MenuItem>
                                <MenuItem value="Radio">Radio</MenuItem>
                                <MenuItem value="Altro">Altro</MenuItem>
                            </Select>
                        <br />
                            </div>
                        <br />
                        <br />
                        <p>
                        {lang[this.props.language].confscreen_account_edit_account_img}:  
                          <i>
                            {this.state.userData.location.pic}
                          </i>
                        </p>
                        <br />
                        <div className="col-6">
                            <TextField
                                label={lang[this.props.language].confscreen_account_edit_account_txt_img}
                                type="text"
                                helperText={this.state.txtImageError ? 'Please enter valid url!' : ''}
                                name="Img"
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                onChange={this.onChangeUrlImg}
                            />
                        </div>
                        <p>
                        {lang[this.props.language].confscreen_account_edit_account_img_preview}: 
                        </p>
                        <img src={this.state.newUrl} alt="Immagine non valida" title="Immagine gestore" className={classes.ImgHome} />
                        <br />
                        <br />
                        <button className={`btn ${classes.ButtonGray} ${classes.TxtLeft}`} type="button" onClick={this.updateAccount}>{lang[this.props.language].confscreen_account_edit_account_btn_update}</button>
                    </div>
                  </div>
                </div>
                <div className="col" />
                <ReactTooltip />
                </div>
            ) 
            : ''
        }
        {
            this.state.showBlock === 'address' 
            ? (
                <div className="row">
                <div className="col" />
                <div className={`col-8 ${classes.DefCard}`}> 
                
                  <div className="row">
                    <div className="col-12">
                      <br />
                      <h3> 
                      {lang[this.props.language].confscreen_account_edit_addr_title}
                        <i data-html="true" data-place="right" data-tip={lang[this.props.language].confscreen_account_edit_addr_hint} className={`fas fa-question-circle ${classes.HelpIcon} ${classes.TxtLeft}`} />
                      </h3>
                      <br />
            <p><b>{lang[this.props.language].confscreen_account_edit_addr_actual}</b>: {this.state.userData.location.address} (LAT/LONG {this.state.userData.location.lat}/{this.state.userData.location.lng})</p>
                      <br />
                      <p><b><u>{lang[this.props.language].loginscreen_about_spot_map_attention}</u>: {lang[this.props.language].loginscreen_about_spot_map_hint}..</b></p>
                        <div className="col-10">
                          <Map link={this.link} mylat={this.state.userData.location.lat} mylng={this.state.userData.location.lng} />
                        </div>
                        <br />
                        <button className={`btn ${classes.ButtonGray} ${classes.TxtLeft}`} type="button" onClick={this.updateAccountAddress}>{lang[this.props.language].confscreen_account_edit_account_btn_update}</button>
                    </div>
                  </div>
                </div>
                <div className="col" />
                <ReactTooltip />
                </div>
            ) 
            : ''
        }
        {
            this.state.showBlock === 'deleteAccount' 
            ? (
                <div className="row">
                <div className="col" />
                <div className={`col-8 ${classes.DefCardAlert}`}> 
                
                  <div className="row">
                    <div className="col-12">
                      <br />
                      <h3> 
                      {lang[this.state.language].confscreen_account_delete_account_title}
                        <i data-html="true" data-place="right" data-tip="Elimina il tuo Moramma Spot" className={`fas fa-question-circle ${classes.HelpIcon} ${classes.TxtLeft}`} />
                      </h3>
                      <br />
                      <p>{lang[this.state.language].confscreen_account_delete_account_description}</p>
                      <br />
                        <br />
                        <br />
                        <button className={`btn ${classes.ButtonGray} ${classes.TxtLeft}`} type="button" onClick={this.deleteAccount}>{lang[this.state.language].confscreen_account_delete_account_btn_delete}</button>
                    </div>
                  </div>
                </div>
                <div className="col" />
                <ReactTooltip />
                </div>
            ) 
            : ''
        }

        </div>  
        <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
        <ReactTooltip />
      </Aux>
    );
  }
} 

export default ConfigurationScreenContentAccount;
